import { FC } from 'react';
import Button from '@components/common/button';
import styles from './styles.module.scss';
import { TOrder } from '@xeppt/xeppt-sdk/types';
import OrdersTable from '@components/orders_table';
import Input from '@components/common/input';

interface IProps {
    orders: TOrder[];
    isOrdersLoading?: boolean;
    toggleFilter: () => void;
    refetchOrders: () => void;
    activeFilterCount: number;
    search: string;
    onSearch: (val: string) => void;
}

const TableOrderSection: FC<IProps> = ({
    orders,
    toggleFilter,
    isOrdersLoading,
    refetchOrders,
    activeFilterCount,
    search,
    onSearch
}) => {
    return (
        <div className={styles.wrapper}>
            <div className={styles.table_header}>
                <Input
                    placeholder="Search by order ID or reference code..."
                    leftIcon="search"
                    value={search}
                    onChange={onSearch}
                    className={styles.search}
                />
                <div />
                <div className={styles.right}>
                    <Button
                        variant="outlined-primary"
                        size="medium"
                        leftIcon="download"
                        onClick={() => {}}>
                        Download
                    </Button>
                    <Button
                        variant="primary"
                        size="medium"
                        leftIcon="filter"
                        onClick={toggleFilter}>
                        {`Filters${activeFilterCount > 0 ? ` (${activeFilterCount})` : ''}`}
                    </Button>
                </div>
            </div>
            <div className={styles.content}>
                <OrdersTable
                    isOrdersLoading={isOrdersLoading}
                    orders={orders}
                    refetchOrders={refetchOrders}
                />
            </div>
        </div>
    );
};

export default TableOrderSection;
